import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import sheet from '@/components/sheet/sheet.vue';
import addblock from "../recovery/components/add.vue";
import viewArticles from "../recovery/components/viewArticles.vue";
import recoveryUp from '@/components/recoveryUp';
import contentView from "../email/components/contentView.vue";
import { recycleList, banUser, serverList, sendMailnew, dorecycleItem } from "@/api/gmtool/packageCode";
import { gmTool } from "@/mixins/index";
export default {
  name: "recovery",
  components: {
    addblock: addblock,
    viewArticles: viewArticles,
    recoveryUp: recoveryUp,
    contentView: contentView,
    sheet: sheet
  },
  mixins: [gmTool],
  data: function data() {
    return {
      advanced: false,
      tableData: [],
      // 表格数据
      value1: '',
      paramsData: {
        page: 1,
        role_id: ''
      },
      listB: [],
      total: 0,
      isCsv: false,
      sheetData: []
    };
  },
  created: function created() {// this.getList()
  },
  activated: function activated() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getList(1);

              _this.getserverList();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getList: function getList(e) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.reqLoading = true;
                _this2.paramsData.page = e;
                recycleList(_this2.paramsData).then(function (res) {
                  if (res.status == 200) {
                    _this2.tableData = res.data.result;
                    _this2.total = res.data.total;
                  }
                }).finally(function () {
                  _this2.reqLoading = false;
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    Renewal: function Renewal() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.getserverList();

              case 2:
                _this3.getList(1);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    recovery: function recovery(data) {
      var _this4 = this;

      this.$confirm(this.$t('confirmRecycleOperation'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                sendMailnew({
                  id: data.email_id,
                  is_prod: _this4.paramsData.is_prod,
                  game_id: _this4.rawData.game_id
                }).then(function (res) {
                  if (res.status == 200) {
                    dorecycleItem({
                      id: data.id,
                      is_prod: _this4.paramsData.is_prod
                    }).then(function (rres) {
                      if (rres.status == 200) {
                        _this4.$message({
                          type: "success",
                          message: _this4.$t('recoverySuccess')
                        });

                        _this4.getList(_this4.paramsData.page);
                      }
                    });
                  }
                });

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      })));
    }
  }
};